import { cn } from '../utilities.ts'
import { IconProps, IconType } from './types.ts'

export const LeftChevronIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-left', type, className)}></i>
}

export const RightChevronIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-right', type, className)}></i>
}

export const PlusIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-plus', type, className)}></i>
}

export const MinusIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-minus', type, className)}></i>
}

export const CheckMarkIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-check', type, className)}></i>
}

export const DownChevronIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-down', type, className)}></i>
}

export const LeftArrowIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-arrow-left', type, className)}></i>
}

export const RightArrowIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-arrow-right', type, className)}></i>
}

export const CheckCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-check-circle', type, className)}></i>
}

export const CircleArrowsIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-arrows-circle', type, className)}></i>
}

export const ChevronDownIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-down', type, className)}></i>
}

export const BlackArrowRightIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-black-right', type, className)}></i>
}

export const BlackArrowLeftIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-black-left', type, className)}></i>
}

export const SwitchArrowIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-arrow-right-left', type, className)}></i>
}
